import { useEffect } from "react";
import { clientNeoFact, clientUploadNeoFact } from "@neonumy/api-clients";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  GET_SEPA_ORDERS,
  LIST_SEPA_ORDERS,
  CREATE_SEPA_ORDER,
  UPDATE_SEPA_ORDER,
} from "queries/centralApi/clients";
import { onErrorGraphql } from "utils/onErrorGraphql";

export default function useSepaOrderApi(id?: ID) {
  const [
    listSepaOrders,
    {
      refetch: listSepaOrdersRefetch,
      loading: listSepaOrdersLoading,
      data: listSepaOrdersData,
      error: listSepaOrdersError,
    },
  ] = useLazyQuery<ListSepaOrdersResponse, ListSepaOrdersVars>(LIST_SEPA_ORDERS, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (listSepaOrdersError) onErrorGraphql(listSepaOrdersError);
  }, [listSepaOrdersError]);

  const sepaOrdersData: ListSepaOrdersResults =
    listSepaOrdersData?.listSepaOrders?.results?.map(item => ({
      ...item,
      key: item.id,
    })) ?? [];

  const listSepatotalCount = listSepaOrdersData?.listSepaOrders?.totalCount ?? 0;

  const [
    getSepaOrder,
    { refetch: refetchGetSepaOrder, data: getSepaOrderData, error: getSepaOrderError },
  ] = useLazyQuery<GetSepaOrderResponse, GetVarTypeID>(GET_SEPA_ORDERS, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getSepaOrderError) onErrorGraphql(getSepaOrderError);
  }, [getSepaOrderError]);

  const sepaOrder: GetSepaOrderData | undefined = getSepaOrderData?.getSepaOrder;

  const [
    createUpdateSepaOrder,
    { loading: createUpdateSepaOrderLoading, error: createUpdateSepaOrderError },
  ] = useMutation<CreateUpdateSepaOrderMutationResponse, CreateUpdateSepaOrderVars>(
    id ? UPDATE_SEPA_ORDER : CREATE_SEPA_ORDER,
    {
      client: clientUploadNeoFact,
      fetchPolicy: "no-cache",
    },
  );

  useEffect(() => {
    if (createUpdateSepaOrderError) onErrorGraphql(createUpdateSepaOrderError);
  }, [createUpdateSepaOrderError]);

  return {
    createUpdateSepaOrderLoading,
    listSepaOrdersLoading,
    createUpdateSepaOrder,
    listSepaOrdersRefetch,
    refetchGetSepaOrder,
    listSepatotalCount,
    sepaOrdersData,
    listSepaOrders,
    getSepaOrder,
    sepaOrder,
  };
}
